import React from 'react';
import {
    Select,
    Stack
} from '@shopify/polaris';
import { SelectFilterTypes } from '../common/Helpers';

const smartCollectionOptions = [
    { label: 'products belong to', value: 'BelongsTo' },
    { label: 'products do NOT belong to', value: 'DoesNotBelongTo' },
];

class ProductSmartCollectionFilterComponent extends React.Component {

    state = {};

    render() {

        let collectionItems = this.props.smartCollections.map((_) => {
            return { "label": _.title, "value": _.id };
        }
        );
        let allCollectionItems = [
            { label: "--- Choose smart collection ---", value: "" },
            ...collectionItems,
        ];

        return (<Stack alignment="center" spacing="tight">
            <Select
                options={SelectFilterTypes}
                value={this.props.filter.filterType}
                onChange={(selected, id) => this.onFilterTypeChange(selected)}
            />
            <Select
                options={smartCollectionOptions}
                value={this.props.filter.condition}
                onChange={(selected, id) => this.onConditionChange(selected)}
            />
            <Select
                options={allCollectionItems}
                value={this.props.filter.productCollectionId}
                onChange={(selected, id) => this.onProductcollectionIdChange(selected)}
            />
        </Stack>);
    }

    onFilterTypeChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.filterType = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onConditionChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.condition = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onProductcollectionIdChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.productCollectionId = newValue;

        this.props.onFilterUpdated(newFilter);
    }
}

export default ProductSmartCollectionFilterComponent;
